// BE vbdt — VBDT/Controllers/NotificationController.cs (Cụm cá nhân)
export const apiNotificationMe = '/api/notifications/me'
export const apiNotificationMeById = (id: string) => `/api/notifications/me/${id}`
export const apiNotificationUnreadCount = '/api/notifications/unread-count'
export const apiNotificationTotalCount = '/api/notifications/total-count'
export const apiNotificationReadAll = '/api/notifications/read-all'
// SignalR hub (không nằm dưới /api) — kênh realtime duy nhất, thay cho SSE tự viết cũ
export const apiNotificationHub = '/hubs/notification'
export const apiNotificationRead = (id: string) => `/api/notifications/${id}/read`
export const apiNotificationHasUnread = '/api/notifications/has-unread'
